module.exports = __webpack_public_path__ + "static/fonts/Inter-Medium.5ff1f2a9.ttf";